import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Tabs, Tab } from 'react-bootstrap';

// Tabs
import StaffPaymentsHourTab from './StaffPaymentsHourTab';
import StaffPaymentsNationalTab from './StaffPaymentsNationalTab';
import StaffPaymentsInternationalTab from './StaffPaymentsInternationalTab';
import getLocale from '../../../i18n/getLocale';

class StaffPaymentsTab extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      key: 1,
      loaded: 0,
      training_certification_staff_payments_national: [],
      training_certification_staff_payments_international: [],
      training_certification_staff_payments_hours: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.training_certification_staff_payments_hours)) {
      this.setState({training_certification_staff_payments_hours: newProps.training_certification_staff_payments_hours});
    }
    if(Array.isArray(newProps.training_certification_staff_payments_international)) {
      this.setState({training_certification_staff_payments_international: newProps.training_certification_staff_payments_international});
    }
    if(Array.isArray(newProps.training_certification_staff_payments_national)) {
      this.setState({training_certification_staff_payments_national: newProps.training_certification_staff_payments_national});
    }
  }

  render() {
    return (
<div>
  <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
    <Tab eventKey={1} title={this.locale.Tripulantes.EditarFuncionario.tabPagamentos.tabHoras.tituloTab}>
      <StaffPaymentsHourTab handleAlert={this.handleAlert} training_certification_staff_payments_hours={this.state.training_certification_staff_payments_hours} />
    </Tab>
    <Tab eventKey={2} title={this.locale.Tripulantes.EditarFuncionario.tabPagamentos.tabDiariaNacional.tituloTab}>
      <StaffPaymentsNationalTab handleAlert={this.handleAlert} training_certification_staff_payments_national={this.state.training_certification_staff_payments_national} />
    </Tab>
    <Tab eventKey={3} title={this.locale.Tripulantes.EditarFuncionario.tabPagamentos.tabDiariaInternacional.tituloTab}>
      <StaffPaymentsInternationalTab handleAlert={this.handleAlert} training_certification_staff_payments_international={this.state.training_certification_staff_payments_international} />
    </Tab>
  </Tabs>
</div>
    );
  }
}

export default StaffPaymentsTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffPaymentsTab.js